import { HealthPlan, MealPlan } from "../../../utils/api-objects/meal-plan";
import { Folder } from "../../../utils/Enums";
import { handleDayOfMonth, handleMonth, handleYear } from "../../../utils/Functions";
import { FolderBox } from "./FolderBox";

interface MostRecentPlanBoxProps {
    planType: "Health Plan" | "Meal Plan";
    plan: HealthPlan | MealPlan;
    onClick: () => void;
}

const MostRecentPlanBox: React.FC<MostRecentPlanBoxProps> = ({ planType, plan, onClick }) => {
    const formattedDate = `${handleDayOfMonth(plan.updated_at)} ${handleMonth(plan.updated_at)} ${handleYear(plan.updated_at)}`;
    return (
        <div className="space-y-[25px]">
            <div className="font-bold text-[16px] leading-[33px]">{planType}</div>
            <FolderBox
                folder={planType === "Health Plan" ? Folder.HealthPlan : Folder.MealPlan}
                pointer={true}
                textThree={`Ultimo aggiornamento: ${formattedDate}`}
                onClick={onClick}
            />
        </div>
    )
}

export default MostRecentPlanBox
